var $ = require('jquery');

"use strict";

var PLUGIN_NAME = "faq";

var DEFAULTS = {
    allowOpenAll: false
};

// The actual plugin constructor
function Faq(element, options) {
    this.element = element;

    this.options = $.extend(true, {}, DEFAULTS, options);
    this._defaults = DEFAULTS;
    this._name = PLUGIN_NAME;
    this.initialise();
}

/**
 * read FAQ items, open first, bind clicks
 */
Faq.prototype.initialise = function() {
    this.$items = $('.panel', $(this.element));

    if (this.$items.size() > 0) {
        this.openCurrentOnly(this.$items[0]);
        this.bindEvents();
    }
};

/**
 * opens selected FAQ item, others are closed
 * @param item
 */
Faq.prototype.openCurrentOnly = function(item) {
    $(this.$items).each(function() {
        $('.panel-body', this).hide();
        $(this).data('closed', "1").addClass('closed');
    });
    $(item).data('closed', "0").removeClass('closed');
    $('.panel-body', $(item)).slideDown(400);
};

/**
 * opens or closes selected FAQ item, others remain untouched
 * @param item
 */
Faq.prototype.toggleCurrent = function(item) {
    $(item).toggleClass('closed');
    $('.panel-body', $(item)).slideToggle(400);
    $(item).data('closed') == "1" ? $(item).data('closed', "0") : $(item).data('closed', "1");
};

Faq.prototype.bindEvents = function() {
    var self = this;

    $(this.$items).each(function() {
        $('.panel-heading', this).bind('click', function() {
            var $item = $(this).parent();
            if (self.options.allowOpenAll) {
                self.toggleCurrent($item);
            } else {
                if ($item.data('closed') == "1") {
                    self.openCurrentOnly($item);
                }
            }
        });
    });
};

/**
 * decide, which methods will be "public"
 */
var API = {
    //action: Faq.prototype.action
};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *         if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *         if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function(value) {
    var args = arguments;

    return this.each(function() {
        var $this = $(this);

        // get plugin instance
        var plugin = $this.data('plugin_' + PLUGIN_NAME);

        // if there's not, create one
        if (!plugin) {
            plugin = new Faq(this, value);
            $this.data('plugin_' + PLUGIN_NAME, plugin);
        }
        // if there is and first parameter is in predefined API methods, call it with rest of params
        else if (API[value]) {
            plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
        }
    });
};


// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.faq.js